<script setup>
import {useHttpErrorsHandler} from "../../Composables/httpErrorsHandler.js";
import {useRouter} from "vue-router";
import {onBeforeMount, reactive, ref} from "vue";
import Loader from "../../Components/Loader.vue";
import FormTextField from "../../Components/FormTextField.vue";
import FormSwitch from "../../Components/FormSwitch.vue";
import FormDatePicker from "../../Components/FormDatePicker.vue";
import FormSelectField from "../../Components/FormSelectField.vue";
import {useToast} from "vue-toast-notification";
import FormSelectCenter from "../../Components/FormSelectCenter.vue";
import FormTextarea from "../../Components/FormTextarea.vue";
import FormSelectSearchUser from "../../Components/FormSelectSearchUser.vue";

const $toast = useToast();
const { httpErrorsHandler } = useHttpErrorsHandler();
const router = useRouter();

const loading = ref(false)
const form = reactive( {
    name: null,
    categorizable_type: null,
    default_user_id: null,
})
const defaultUserPreSelected = ref(null)
const errors = ref(null)
function updateNewsCategory() {

    loading.value = true;
    let formData = new FormData();

    Object.entries(form).forEach(([key, value]) => {
        if (value !== null && value !== '') {
            formData.append(key, value);
        }
    });

    formData.append('_method', 'PUT');
    axios.post("/api/categories/" + router.currentRoute.value.params.id, formData)
        .then(response => {
            $toast.success('Catégorie modifiée avec succès', {
                position: 'top',
                duration: 5000,
                dismissible: true,
                pauseOnHover: true,
            });
            router.back();
        })
        .catch(error => {
            errors.value = error.response.data.errors;
            httpErrorsHandler(error);
            loading.value = false;
        });
}

function getNewsCategory() {
    loading.value = true;
    axios.get("/api/categories/" + router.currentRoute.value.params.id)
        .then(response => {
            Object.entries(response.data.data).forEach(([key, value]) => {
                if(form.hasOwnProperty(key)){
                    form[key] = value;
                }
            });
            if (response.data.data.default_user) {
                defaultUserPreSelected.value = response.data.data.default_user;
            }
            loading.value = false;
        })
        .catch(error => {
            httpErrorsHandler(error);
            loading.value = false;
        });
}
onBeforeMount(() => {
    getNewsCategory()
})

</script>

<template>
    <div class="row">
        <div class="col-lg-12">
            <!--Loader-->
            <div class="card" v-show="loading">
                <div class="card-body">
                    <loader/>
                </div>
            </div>
            <!--Form-->
            <form v-on:submit.prevent="updateNewsCategory" v-show="!loading">
                <div class="card">
                    <div class="card-header align-items-center d-flex">
                        <h4 class="card-title mb-0 flex-grow-1"><i class="mdi mdi-bookmark-plus-outline me-2 align-middle fs-4"></i>Modifier une catégorie</h4>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <form-text-field
                                name="name"
                                label="Nom de la catégorie"
                                :label-hidden="false"
                                @update:field="form.name = $event"
                                :errors="errors"
                                :required="true"
                                :data="form.name"
                                bs-class="col-md-6"
                            />

                            <form-select-search-user
                                name="default_user_id"
                                label="Utilisateur par défaut"
                                placeholder="Rechercher un utilisateur..."
                                :errors="errors"
                                :required="false"
                                roles="admin,back_office"
                                :user-pre-selected="defaultUserPreSelected"
                                @update:field="form.default_user_id = $event?.id ?? null"
                                bs-class="col-md-6"
                            />

                            <div class="d-flex gap-2 justify-content-end">
                                <button type="button" class="btn btn-soft-dark" @click="router.back()">Retour</button>
                                <button type="submit" class="btn btn-secondary">Valider</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<style scoped>

</style>
